import {
	Checkbox,
	FormItem,
	ValidationError
} from "client/Components";
import { TagKind } from "client/Api/Tags/tags";
import { IObjectInputAttachable } from "client/Forms/attachable";
import { ReactElement } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { HubItemComposerDialog } from "../../HubItemComposerDialog/HubItemComposerDialog";
import {
	KnowledgeItemSaveModel,
	KnowledgeItemStatus
} from "client/Api/KnowledgeItemManagement/knowledgeItemManagement";
import { HubTagSelect } from "client/Features/Hub/Builder/HubTagSelect";
import { HubHierarchyListNodeModel } from "client/Api/Hub/common.composer";

const {
	Title,
	Step,
	CategorySelect,
	Content,
	FormContainer
} = HubItemComposerDialog;

export type SettingsStepProps = {
	isActive: boolean;
	attachable: IObjectInputAttachable<KnowledgeItemSaveModel>;
	status: KnowledgeItemStatus;
	categoryHierarchy: readonly HubHierarchyListNodeModel[];
	hasPermissionToCreateNewCategory: boolean;
	onCreateNewCategory(): Promise<void>;
	infoAlerts?: ReactElement;
};

export const SettingsStep = (props: SettingsStepProps): ReactElement => {
	const {
		isActive,
		attachable,
		status,
		categoryHierarchy,
		onCreateNewCategory,
		hasPermissionToCreateNewCategory,
		infoAlerts
	} = props;

	const isArchived: boolean = status === KnowledgeItemStatus.Archived;

	return (
		<Step
			isActive={isActive}
			trackingId="settings-step"
		>
			<Content>
				{infoAlerts}
				<FormContainer>
					<Title text={localize("_Settings")} />
					<FormItem
						label={localize("_Category")}
						isRequired
					>
						<CategorySelect
							attachable={attachable.for("categoryId")}
							categoryHierarchy={categoryHierarchy}
							hasPermissionToCreateNewCategory={hasPermissionToCreateNewCategory}
							isArchived={isArchived}
							onCreateNewCategory={onCreateNewCategory}
							menuTitle={localize("_Category")}
						/>
						<ValidationError {...attachable.for("categoryId").attachToValidationError()} />
					</FormItem>
					<FormItem label={localize("_PinArticle")}>
						<Checkbox
							{...attachable.for("isPinned").attachToCheckbox()}
							text={localize("_PinArticleToTopOfCategoryPage")}
							isDisabled={isArchived}
						/>
						<ValidationError {...attachable.for("isPinned").attachToValidationError()} />
					</FormItem>
					<FormItem label={localize("_Tags")}>
						<HubTagSelect
							attachable={attachable.for("tags")}
							kind={TagKind.KnowledgeItem}
							isDisabled={isArchived}
							menuTitle={localize("_Tags")}
						/>

						<ValidationError {...attachable.for("tags").attachToValidationError()} />
					</FormItem>
					<FormItem label={localize("_Author")}>
						<Checkbox
							{...attachable.for("showAuthor").attachToCheckbox()}
							text={localize("_ShowAuthorOnArticle")}
							isDisabled={isArchived}
						/>
						<ValidationError {...attachable.for("showAuthor").attachToValidationError()} />
					</FormItem>
					<FormItem label={localize("_Comments")}>
						<Checkbox
							{...attachable.for("areCommentsEnabled").attachToCheckbox()}
							text={localize("_AllowComments")}
							isDisabled={isArchived}
						/>
						<ValidationError {...attachable.for("areCommentsEnabled").attachToValidationError()} />
					</FormItem>
				</FormContainer>
			</Content>
		</Step>
	);
};
SettingsStep.displayName = "SettingsStep";
